import React, { useMemo } from "react";
import moment from 'moment';
import { LinearProgress, Paper, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DataTable from "react-data-table-component";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import { Link } from "react-router-dom";

const sortIcon = <ArrowDownward />;

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
        table: {
            minWidth: 650,
        },
    },
    btn: {
        margin: theme.spacing(4)
    }
}));

const NotificationList = ({ giftsList }) => {
    const classes = useStyles();
    const heading = [
        {
            name: "Sr. No",
            wrap: true,
            sortable: true,
            cell: (row, index) => index + 1
        }, {
            name: "Image",
            wrap: true,
            sortable: true,
            cell: (giftsList) => <>
                {
                    giftsList.image ?
                        <a target="_blank" href={giftsList.image} style={{ textDecoration: 'none' }}>
                            <img src={giftsList.image} alt="Img" style={{ width: "50px", height: "50px" }} />
                        </a> : <p style={{ textAlign: "center" }}>-</p>
                }
            </>
        }, {
            name: "Title",
            selector: "title",
            wrap: true,
            sortable: true
        }, {
            name: "Message",
            selector: "message",
            wrap: true,
            sortable: true
        }, {
            name: "User Count",
            wrap: true,
            sortable: true,
            cell: (giftsList) => (
                <Link to="/dashboard/users" style={{ textDecoration: 'none' }}>
                    <p>{giftsList && giftsList.toUsers && giftsList.toUsers.length}</p>
                </Link>
            )
        }, {
            name: "Date",
            wrap: true,
            sortable: true,
            cell: (giftsList) => (
                <p>{giftsList && giftsList.createdAt ? moment(new Date(giftsList.createdAt)).format('DD/MM/YYYY hh:mm') : ""}</p>
            )
        }
    ];

    const safeData = Array.isArray(giftsList) ? giftsList : [];

    // Debug log (remove in production)
    // console.log("GiftsDataTable safeData:", safeData, "isArray:", Array.isArray(giftsList));

    const columns = useMemo(
        () => [
            {
                name: "Sr. No",
                wrap: true,
                sortable: true,
                cell: (row, index) =>
                    typeof index === "number" ? <div>{index + 1}</div> : <div>{safeData.findIndex((r) => r._id === row._id) + 1}</div>,
                width: "80px",
            },
            {
                name: "Image",
                wrap: true,
                sortable: false,
                cell: (row) => (
                    <>
                        {
                            giftsList.image ?
                                <a target="_blank" href={giftsList.image} style={{ textDecoration: 'none' }}>
                                    <img src={giftsList.image} alt="Img" style={{ width: "50px", height: "50px" }} />
                                </a> : <p style={{ textAlign: "center" }}>-</p>
                        }
                    </>
                ),
            },
            {
                name: "Title",
                selector: (row) => row.title ?? "-",
                wrap: true,
                sortable: true,
            },
            {
                name: "Message",
                selector: (row) => row.message ?? "-",
                wrap: true,
                sortable: true,
            },
            {
                name: "User Count",
                wrap: true,
                sortable: false,
                cell: (row) => (
                    <Link to="/dashboard/users" style={{ textDecoration: "none" }}>
                        <div>{Array.isArray(row?.toUsers) ? row.toUsers.length : 0}</div>
                    </Link>
                ),
                width: "120px",
            },
            {
                name: "Date",
                wrap: true,
                sortable: true,
                cell: (row) => <div>{row?.createdAt ? moment(row.createdAt).format("DD/MM/YYYY hh:mm") : ""}</div>,
                width: "160px",
            }
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [safeData]
    );

    return (
        <div>
            {!giftsList ? (
                <LinearProgress color="primary" />
            ) : (
                <Paper className={classes.paper} square>
                    <Link to='/dashboard/send-notification'>
                        <Button variant="contained" color="primary" className={classes.btn}>Send Notification</Button>
                    </Link>
                    <DataTable
                        columns={columns}
                        data={safeData}
                        noHeader
                        pagination
                        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                        // remove sortIcon while debugging; set to a React element only after validating its type
                        // sortIcon={sortIcon}
                        striped
                        highlightOnHover
                        responsive
                    />
                </Paper>
            )}
        </div>
    );
};

export default NotificationList;
